<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center mb-3">
    <span class="p-input-icon-left flex-grow-1 mr-3">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        (input)="funeralCostsTable.filterGlobal($any($event).target.value, 'contains')"
        placeholder="Search funeral costs"
      />
    </span>
    <p-dropdown
      class="mr-3 flex-shrink-0"
      [options]="regionFilterOptions"
      [(ngModel)]="selectedRegion"
      (onChange)="onRegionFilter(funeralCostsTable, $event.value)"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      [style]="{ 'min-width': '11rem' }"
    ></p-dropdown>
    <button
      pButton
      pRipple
      type="button"
      label="Add package"
      icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0"
      (click)="onAddFuneralCost($event)"
    ></button>
  </div>

  <p-table
    #funeralCostsTable
    [value]="funeralCostsAsList(account.data?.funeralCosts)"
    [globalFilterFields]="['name', 'slug', 'tagline']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Slug</th>
        <th>Region</th>
        <th>Featured</th>
        <th>Price</th>
        <th style="width: 12rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-package>
      <tr [pSelectableRow]="package" [class.is-deleted]="package._meta.deleted">
        <td>
          <strong>{{ package.name || '(unnamed)' }}</strong>
          <div *ngIf="package.tagline" class="text-sm muted">{{ package.tagline }}</div>
        </td>
        <td>
          <code *ngIf="package.slug">{{ package.slug }}</code>
          <span *ngIf="!package.slug" class="block text-500 text-sm mt-1">—</span>
        </td>
        <td>
          <span *ngIf="package.region && package.region !== 'global'" class="font-medium">{{ package.region }}</span>
          <span *ngIf="!package.region || package.region === 'global'" class="block text-500 text-sm mt-1">Global</span>
        </td>
        <td>
          <i
            *ngIf="package.isFeatured"
            class="pi pi-star"
            aria-label="Featured package"
            title="Featured on the homepage"
          ></i>
        </td>
        <td>
          <span *ngIf="package.price != null">{{ package.price | currency:'AUD' }}</span>
          <span *ngIf="package.price == null" class="block text-500 text-sm mt-1">POA</span>
        </td>
        <td class="package-actions">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onEditFuneralCost($event, package)"
            class="p-button-rounded p-button-text"
            title="Edit"
          ></button>
          <button
            *ngIf="!package._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-trash"
            (click)="onDeleteFuneralCost($event, package)"
            class="p-button-rounded p-button-danger p-button-text"
            title="Remove"
          ></button>
          <button
            *ngIf="package._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            (click)="onRestoreFuneralCost($event, package)"
            class="p-button-rounded p-button-success p-button-text"
            title="Restore"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="p-text-center muted p-py-5">
          No funeral costs yet. Use "Add funeral cost" to create the first one.
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>

<!-- Shown while the account loads. Without it the modal opens onto an empty
     body for a second or two, which reads as broken rather than busy. -->
<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
